import React, { useEffect, useState } from "react";
import moment from "moment";
import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
`;

const TimeBlock = styled.div`
  font-size: 64px;
  text-align: center;
  width: 80px;
  > span {
    font-size: 10px;
    display: block;
  }
`;

const getCountdown = (time: number) => {
  const now = moment();
  const target = moment(time);
  const duration = moment.duration(target.diff(now, "seconds"), "seconds");
  return [
    duration.days().toString().padStart(2, "0"),
    duration.hours().toString().padStart(2, "0"),
    duration.minutes().toString().padStart(2, "0"),
    duration.seconds().toString().padStart(2, "0"),
  ];
};

interface CounterProps {
  time: number;
}

function Counter({ time }: CounterProps) {
  const [timeLeft, setTimeLeft] = useState<string[]>(getCountdown(time));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown(time));
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  const [days, hours, minutes, seconds] = timeLeft;

  return (
    <Wrapper>
      <TimeBlock>
        {days} <span>days</span>
      </TimeBlock>
      <TimeBlock>
        {hours}
        <span>hours</span>
      </TimeBlock>
      <TimeBlock>
        {minutes}
        <span>minutes</span>
      </TimeBlock>
      <TimeBlock>
        {seconds}
        <span>seconds</span>
      </TimeBlock>
    </Wrapper>
  );
}

export default Counter;
